import { render, staticRenderFns } from "./recommendPage.vue?vue&type=template&id=3f54fa73&scoped=true&"
import script from "./recommendPage.vue?vue&type=script&lang=js&"
export * from "./recommendPage.vue?vue&type=script&lang=js&"
import style0 from "./recommendPage.vue?vue&type=style&index=0&id=3f54fa73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54fa73",
  null
  
)

export default component.exports